import { useCallback, useState } from 'react';

import { FieldsValues } from '../../types';

export const useTouchedFields = () => {
  const [touchedFields, setTouchedFields] = useState<Partial<Record<FieldsValues, string>>>({});

  const setFieldTouched = useCallback((name: FieldsValues) => {
    setTouchedFields((touchedObject) => ({
      ...touchedObject,
      [name]: true,
    }));
  }, []);

  const resetTouchedFields = useCallback(() => {
    setTouchedFields({});
  }, []);

  return {
    touchedFields,
    touchField: setFieldTouched,
    resetTouchedFields,
  };
};
